import { create } from 'zustand';

import { IProfileCompletionModalState } from './interfaces';

export const useProfileCompletionModalState = create<IProfileCompletionModalState>(
  (set) => ({
    open: false,
    setOpen: (open) => set({ open }),
  }),
);
